import { postKycIntegrationMethod } from '@nemuru-eng/js-api-client';

import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { useLoanPaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/hooks/useLoanPaymentIntent';
import { KycIntegrationMethodOwner } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { useMutation } from '@/hooks/useMutation';

export const useSendVerificationEmailMutation = (
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity,
  owner: KycIntegrationMethodOwner,
) => {
  const { updatePaymentMethodEntity } = useLoanPaymentIntent();

  return useMutation({
    mutationFn: async () => {
      const loan = paymentMethodDetailEntity.loan;
      const onboardingDetails =
        owner === KycIntegrationMethodOwner.BORROWER
          ? paymentMethodDetailEntity.borrowerOnboardingDetails()
          : paymentMethodDetailEntity.coBorrowerOnboardingDetails();

      if (!loan || !onboardingDetails) {
        return;
      }

      await postKycIntegrationMethod({
        loanId: paymentMethodDetailEntity.loan.id,
        onboardingDetailsId: onboardingDetails.id,
      });

      await paymentMethodDetailEntity.refreshKycIntegrationMethods();

      updatePaymentMethodEntity(paymentMethodDetailEntity);
    },
  });
};
